/**
 * Constants for Settings Navigation
 */

/**
 * Category order for circular navigation
 * Used by all settings screens for swipe navigation
 */
export const SETTINGS_CATEGORIES = [
  "profile",
  "investableAssets",
  "realEstateAssets",
  "liabilities",
  "income",
  "expenses",
  "assumptions",
] as const;

export type SettingsCategory = (typeof SETTINGS_CATEGORIES)[number];

export const SETTINGS_CATEGORY_LABELS: Record<SettingsCategory, string> = {
  profile: "Profile",
  investableAssets: "Investable Assets",
  realEstateAssets: "Real Estate & Other Assets",
  liabilities: "Liabilities",
  income: "Income",
  expenses: "Expenses",
  assumptions: "Assumptions",
};
